export const getBytesPayload = async (file: File): Promise<Uint8Array> => {
  return new Uint8Array(await new Response(file).arrayBuffer())
}
